import './en.js';
import './ru.js';


// WEBPACK FOOTER //
// ./src/translations/index.js